export default __webpack_public_path__ + "static/media/title_ja_sp.9a2ff697.png";